import { FILTER_TYPE, TableFilters, TABLE_COLUMN } from './filter-table-types';

export const initialFilters: TableFilters = {
  [TABLE_COLUMN.TYPE]: { filterType: FILTER_TYPE.SELECT },
  [TABLE_COLUMN.CONTACT]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.TOTAL_DUE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.TOTAL_OVERDUE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.TOTAL_INVOICED]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.INVOICES_DUE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.AVERAGE_SALE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.DAYS_TO_PAY]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.DEPENDENCE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.LAST_ACTIVITY]: { filterType: FILTER_TYPE.DATE },
  [TABLE_COLUMN.CONTACT_NAME]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.CONVERTED_AMOUNT_DUE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.CONVERTED_AMOUNT_TOTAL]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.DUE_DATE]: { filterType: FILTER_TYPE.DATE },
  [TABLE_COLUMN.INVOICE_NUMBER]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.ISSUE_DATE]: { filterType: FILTER_TYPE.DATE },
  [TABLE_COLUMN.EXPECTED_DATE]: { filterType: FILTER_TYPE.DATE },
  [TABLE_COLUMN.PDF_NAME]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.CREATED_BY]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.SAVED_ON]: { filterType: FILTER_TYPE.DATE },
  [TABLE_COLUMN.REPORT_NAME]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.NEXT_GENERATE_AT]: { filterType: FILTER_TYPE.DATE },
  [TABLE_COLUMN.PERIOD]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.SENDING_TO]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.TIME]: { filterType: FILTER_TYPE.TIME },
  [TABLE_COLUMN.HELD_FOR_REVIEW]: { filterType: FILTER_TYPE.TIME },
  [TABLE_COLUMN.STATUS]: { filterType: FILTER_TYPE.SELECT }
};
